import React, {
    useContext,
    useEffect,
    useState,
    useCallback,
} from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash/throttle';
import cn from 'classnames';
import { analyticService } from 'global/services';

import ClampLines from 'app/components/ClampLines';

import XBig from 'app/assets/svg/x_big.component.svg';

import { BasketContext } from '../BasketProvider';
import { ConfigContext } from '../ConfigProvider';


import './basket-dishes.scss';
import { NYGiftContext } from '../NYGiftContext';


export default function BasketDish({
    id,
    title,
    category,
    price,
    caption = '',
    imageUrl,
    imageUrlDesktop,
    dishCountStep = 0,
    portion,
    originalPriceWithStep,
    discountPriceWithStep,
    buttonsDisabled,
    giftWrapId,
    isGift,
}) {
    const { pageId } = useContext(ConfigContext);
    const { updateBasket, basket } = useContext(BasketContext);

    /* NY2024 GIFT КОСТЫЛИ */
    const {
        addHeadItem,
        romoveById,
        removeAllById,
        isGiftItem,
    } = useContext(NYGiftContext);

    // const commonItemsCount = itemsList.filter((item) => item === '3835').length;

    // eslint-disable-next-line arrow-body-style
    // const modedItemsCount = itemsList.filter((item) => item === '4211').length;

    /* NY2024 GIFT КОСТЫЛИ КОНЕЦ */

    const handleClickIncrease = () => {
        if (portion >= 9) return;

        analyticService.push({
            eventName: 'add_to_cart',
            dishes: [{
                id,
                title,
                caption,
                price,
                portion,
                categoryId: category,
            }],
            source: pageId,
            subscriptionType: 'singlePay',
            typeOfSet: basket.typeOfSet,
        });
        const nextCount = portion + dishCountStep;

        if (isGiftItem(id)) {
            updateBasket({
                dishId: id,
                portions: nextCount,
                onCompletedCallback: () => {
                    addHeadItem(id);
                },
            });
        } else {
            updateBasket({ dishId: id, portions: nextCount });
        }
    };

    const handleClickDecrease = () => {
        const nextCount = portion - dishCountStep;
        /* NY2024 GIFT КОСТЫЛИ */
        if (isGiftItem(id)) {
            updateBasket({
                dishId: id,
                portions: nextCount,
                onCompletedCallback: () => {
                    romoveById(id);
                },
            });
        } else {
            updateBasket({ dishId: id, portions: nextCount });
        }
    };

    const handleClickRemove = () => {
        const nextCount = 0;

        if (isGiftItem(id)) {
            removeAllById(id);
            updateBasket({ dishId: id, portions: nextCount });
        } else {
            updateBasket({ dishId: id, portions: nextCount });
        }
    };

    /* Заставляем ClampLines заново делать обрезку текста при ресайзах */
    const [width, setWidth] = useState(document.documentElement.clientWidth);

    const handleResize = useCallback(throttle(() => {
        setWidth(document.documentElement.clientWidth);
    }, 300), []);

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [handleResize]);
    /* Заставляем ClampLines заново делать обрезку текста при ресайзах */

    const titleClassess = cn({
        'ny__basket-dish__title': true,
        'ny__basket-dish__title--wide': buttonsDisabled,
    });

    return (
        <div styleName="ny__basket-dish__root">
            <div styleName="ny__basket-dish__image">
                <picture>
                    <source media="(max-width: 1023px)" srcSet={imageUrl} />
                    <source media="(min-width: 1024px)" srcSet={imageUrlDesktop} />
                    <img styleName="ny__basket-dish__image-img" src={imageUrl} alt={title} />
                </picture>
            </div>

            <div styleName="ny__basket-dish__right-side">
                <div styleName="ny__basket-dish__title-wrap">
                    <p styleName={titleClassess}>
                        <ClampLines
                            key={width}
                            text={`${title} ${caption}`}
                            linesCount={2}
                            delay={200}
                        />
                    </p>

                    <div styleName="ny__basket-dish__price-container">
                        {!isGift && (
                            <>
                                {originalPriceWithStep && originalPriceWithStep !== discountPriceWithStep && (
                                    <span styleName="ny__basket-dish__origingal-price">
                                        <span styleName="num">
                                            {originalPriceWithStep}
                                            &nbsp;
                                        </span>
                                        ₽
                                    </span>
                                )}
                                <span styleName="ny__basket-dish__discount-price">
                                    <span styleName="num">
                                        {discountPriceWithStep}
                                        &nbsp;
                                    </span>
                                    ₽
                                </span>
                            </>
                        )}
                    </div>
                </div>

                {!isGift && (
                    <div styleName="ny__basket-dish__add-button-container">
                        <button
                            type="button"
                            disabled={buttonsDisabled}
                            styleName="ny__basket-dish__add-button decrease"
                            onClick={handleClickDecrease}
                        >
                            -
                        </button>
                        <span styleName="ny__basket-dish__add-button__text">
                            {portion}
                        </span>
                        <button
                            type="button"
                            disabled={buttonsDisabled}
                            styleName="ny__basket-dish__add-button increase"
                            onClick={handleClickIncrease}
                        >
                            +
                        </button>
                    </div>
                )}
            </div>

            {!buttonsDisabled && !isGift && (
                <button
                    type="button"
                    disabled={buttonsDisabled}
                    styleName="ny__basket-dish__remove-button"
                    onClick={handleClickRemove}
                >
                    <XBig />
                </button>
            )}
        </div>
    );
}

BasketDish.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    dishCountStep: PropTypes.number,
    caption: PropTypes.string,
    imageUrl: PropTypes.string.isRequired,
    imageUrlDesktop: PropTypes.string.isRequired,
    portion: PropTypes.number.isRequired,
    originalPriceWithStep: PropTypes.string.isRequired,
    discountPriceWithStep: PropTypes.string.isRequired,
    buttonsDisabled: PropTypes.bool.isRequired,
    isGift: PropTypes.bool.isRequired,
};
